import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/app.vue").then(m => m.default || m)),
  "store-cart": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/store-cart.vue").then(m => m.default || m)),
  "super-admin": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/super-admin.vue").then(m => m.default || m))
}